import { COUNTRIES_WITHOUT_EN_LOCALE } from './localeHelper';

export const shouldAddEnglishLocale = (countryCode: string): boolean =>
  !COUNTRIES_WITHOUT_EN_LOCALE.includes(countryCode.toUpperCase());
